__turbopack_context__.v({
  "formField": "_-module__w4L6dq__formField",
  "formFieldCheckbox": "_-module__w4L6dq__formFieldCheckbox",
  "registerBtn": "_-module__w4L6dq__registerBtn",
});
